import script from "./hotel.vue?vue&type=script&setup=true&lang=js"
export * from "./hotel.vue?vue&type=script&setup=true&lang=js"

import "./hotel.vue?vue&type=style&index=0&id=9ac3868e&lang=scss"

const __exports__ = script;

export default __exports__